"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _PublicPage = _interopRequireDefault(require("./components/PublicPage.vue"));
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KSAllianceAuthorization',
  components: {
    PublicPage: _PublicPage.default
  },
  data: function data() {
    return {
      name: '快手',
      platformCode: 'KS',
      queryData: {
        code: '',
        id: ''
      }
    };
  },
  created: function created() {
    // 这里可以进行一些初始化操作
    var urlParams = new URLSearchParams(window.location.search);
    // console.log('urlParams:', urlParams)
    var code = urlParams.get('code'); // 获取 code 的值
    var id = urlParams.get('id'); // 获取 code 的值
    this.queryData.code = code;
    this.queryData.id = id;
  }
};